import { render, staticRenderFns } from "./AlterarSenhaTerminal.vue?vue&type=template&id=056bec72"
import script from "./AlterarSenhaTerminal.vue?vue&type=script&lang=js"
export * from "./AlterarSenhaTerminal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports